/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DeleteData,
  DeleteDataResult,
  EmailContainer,
} from '../models/index';
import {
    DeleteDataFromJSON,
    DeleteDataToJSON,
    DeleteDataResultFromJSON,
    DeleteDataResultToJSON,
    EmailContainerFromJSON,
    EmailContainerToJSON,
} from '../models/index';

export interface MaintenanceDeleteUnusedFilesRequest {
    deleteData: DeleteData;
}

export interface MaintenanceDeleteUnusedMetadataRequest {
    deleteData: DeleteData;
}

export interface MaintenanceSendEmailToAllUsersRequest {
    emailContainer: EmailContainer;
}

/**
 * 
 */
export class MaintenanceApi extends runtime.BaseAPI {

    /**
     */
    async maintenanceDeleteUnusedFilesRaw(requestParameters: MaintenanceDeleteUnusedFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteDataResult>> {
        if (requestParameters['deleteData'] == null) {
            throw new runtime.RequiredError(
                'deleteData',
                'Required parameter "deleteData" was null or undefined when calling maintenanceDeleteUnusedFiles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/maintenance/files`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteDataToJSON(requestParameters['deleteData']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteDataResultFromJSON(jsonValue));
    }

    /**
     */
    async maintenanceDeleteUnusedFiles(requestParameters: MaintenanceDeleteUnusedFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteDataResult> {
        const response = await this.maintenanceDeleteUnusedFilesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async maintenanceDeleteUnusedMetadataRaw(requestParameters: MaintenanceDeleteUnusedMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteDataResult>> {
        if (requestParameters['deleteData'] == null) {
            throw new runtime.RequiredError(
                'deleteData',
                'Required parameter "deleteData" was null or undefined when calling maintenanceDeleteUnusedMetadata().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/maintenance/metadata`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteDataToJSON(requestParameters['deleteData']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteDataResultFromJSON(jsonValue));
    }

    /**
     */
    async maintenanceDeleteUnusedMetadata(requestParameters: MaintenanceDeleteUnusedMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteDataResult> {
        const response = await this.maintenanceDeleteUnusedMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async maintenanceSendEmailToAllUsersRaw(requestParameters: MaintenanceSendEmailToAllUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['emailContainer'] == null) {
            throw new runtime.RequiredError(
                'emailContainer',
                'Required parameter "emailContainer" was null or undefined when calling maintenanceSendEmailToAllUsers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/maintenance/send-email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailContainerToJSON(requestParameters['emailContainer']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async maintenanceSendEmailToAllUsers(requestParameters: MaintenanceSendEmailToAllUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.maintenanceSendEmailToAllUsersRaw(requestParameters, initOverrides);
    }

}
